export const splitAvgFormula = (text: string) => {
	const match = text.match(/(\d+) \((\d+d\d+( [+-−] \d+)?)\)/);
	if (match) return [match.at(1), match.at(2)];
	return [text, null];
};
